import React, { useState,useEffect } from 'react'
import "./usernav.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import toastify from '../Util/toastify';
const Usernav = () => {
  const [search,setSeach]=useState("")
  var path=window.location.pathname
  var nav=useNavigate()
  function navigateProfile(){
    if(!((sessionStorage.getItem("c")==='User')||(sessionStorage.getItem("c")==='Seller')||sessionStorage.getItem("c")==='Admin'))
    {
         toastify("You need to login first","error")
         nav('/Login')
    }
    else
    nav('/Profile')
  }
  function navigateCart(){
    if(!((sessionStorage.getItem("c")==='User')||(sessionStorage.getItem("c")==='Seller')||sessionStorage.getItem("c")==='Admin'))
    {
         toastify("You need to login first","error")
         nav('/Login')
    }
    else
    nav('/Cart')
  }
  function navigateHome(){
    nav('/')
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
       nav('/SearchResults', { state: { search: search} })
       window.location.reload()
    }
  }

  function navigateWishlist(){
    if(!((sessionStorage.getItem("c")==='User')||(sessionStorage.getItem("c")==='Seller')||sessionStorage.getItem("c")==='Admin'))
    {
         toastify("You need to login first","error")
         nav('/Login')
    }
    else
    nav('/Wishlist')
  }
  useEffect(() => {
    if(path==='/MyOrders')
        searchProduct()
   },[search])
   const searchProduct=()=> {
    var nodes = document.getElementsByClassName('target');
    var i
    for (i = 0; i < nodes.length; i++) {
      var str=search.toLowerCase()
      if (nodes[i].innerText.toLowerCase().includes(str)) {
         if(nodes[i].style.display==="none")
             nodes[i].style=''
      } else {
        nodes[i].style.display = "none";
      }
    }
  }
  return (
    <>
    <div className="d-flex mb-1 mt-1" style={{ marginLeft: "auto" }}>
    <div className='col-lg-2 col-md-2 usernav' style={{width: "40%"}}>
    <img src='https://res.cloudinary.com/vcart/image/upload/v1658298828/Screenshot__131_-removebg-preview_mtjdmd.png' style={{height:"30px", marginTop:"5"}} alt="VCART" onClick={()=>navigateHome()}/>
    </div>
    <div className='col-lg-8 col-md-8 d-none d-lg-block d-xl-block'>
            <input id='search' className="searchUser" type="text" placeholder="Search for products, brand and more" name="search" value={search} 
            onChange={(e)=>setSeach(e.target.value)} onKeyDown={handleKeyDown}/>
    </div>
    <div className='userIcons my-auto d-none d-lg-block d-xl-block'>
    <a onClick={navigateCart}><i className="fas fa-shopping-cart mx-3"></i></a> 
    <a onClick={navigateWishlist}><i className="fas fa-heart mx-3"></i></a>
    <a onClick={navigateProfile}><i className="fas fa-user-circle mx-3"></i></a>
    </div>
    <div className='userIconsSM my-auto pl-20 d-block d-lg-none d-md-block d-xl-none'>
    <a onClick={navigateCart}><i className="fas fa-shopping-cart mx-3"></i></a> 
    <a onClick={navigateWishlist}><i className="fas fa-heart mx-3"></i></a>
    <a onClick={navigateProfile}><i className="fas fa-user-circle mx-3"></i></a>
    </div>
    </div>
    </>
  )
}

export default Usernav